module.exports = __webpack_public_path__ + "static/img/funny_19.2693c394.jpg";